module.exports = __webpack_public_path__ + "img/LogoSSE.1a233e55.png";